webpackJsonp([12000714755304038000],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/photos-lofoten.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"name": "lofoten",
			"photos": [
				"lofoten/DSC_1820.jpg",
				"lofoten/DSC_1845.jpg",
				"lofoten/DSC_1877.jpg",
				"lofoten/DSC_1922.jpg",
				"lofoten/DSC_1940.jpg",
				"lofoten/DSC_1946.jpg",
				"lofoten/DSC_1963-Pano.jpg",
				"lofoten/DSC_1966.jpg",
				"lofoten/DSC_1983-Pano.jpg",
				"lofoten/DSC_1986.jpg",
				"lofoten/DSC_1991.jpg",
				"lofoten/DSC_2007-Pano.jpg",
				"lofoten/DSC_2008.jpg",
				"lofoten/DSC_2024.jpg",
				"lofoten/DSC_2031.jpg",
				"lofoten/DSC_2042.jpg",
				"lofoten/DSC_2100.jpg",
				"lofoten/DSC_2104-Pano.jpg",
				"lofoten/DSC_2112.jpg",
				"lofoten/DSC_2115.jpg",
				"lofoten/DSC_2120.jpg",
				"lofoten/DSC_2130.jpg",
				"lofoten/DSC_2132.jpg",
				"lofoten/DSC_2141.jpg",
				"lofoten/DSC_2164-Edit.jpg",
				"lofoten/DSC_2165.jpg",
				"lofoten/DSC_2167.jpg",
				"lofoten/DSC_2172.jpg",
				"lofoten/DSC_2192.jpg",
				"lofoten/DSC_2202.jpg",
				"lofoten/DSC_2206.jpg",
				"lofoten/DSC_2217.jpg",
				"lofoten/DSC_2219-Pano.jpg",
				"lofoten/DSC_2233.jpg",
				"lofoten/DSC_2247.jpg",
				"lofoten/DSC_2262.jpg",
				"lofoten/DSC_2279.jpg",
				"lofoten/DSC_2287.jpg",
				"lofoten/DSC_2288.jpg",
				"lofoten/DSC_2299-Pano.jpg",
				"lofoten/DSC_2318.jpg",
				"lofoten/DSC_2323.jpg",
				"lofoten/DSC_2333-Pano-Edit.jpg",
				"lofoten/DSC_2355.jpg"
			],
			"next": {
				"name": "berlin"
			},
			"previous": null
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---photos-lofoten-7e138376cb79ee389129.js